exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-photo-page-js": () => import("./../../../src/pages/photoPage.js" /* webpackChunkName: "component---src-pages-photo-page-js" */),
  "component---src-pages-tag-page-js": () => import("./../../../src/pages/tagPage.js" /* webpackChunkName: "component---src-pages-tag-page-js" */)
}

